import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { orange } from "@/pages/(app)/home/components/colors";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import useTranslation from "@babackapp/translations/use-translation";
import { ClipboardX } from "lucide-react";
import { useCallback, useEffect } from "react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import QuickFilterItem from "./quick-filter-item";

export default function TreatedWithoutLogisticianInspectionQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const status = filters.get("status");
  const active =
    !status && quickFilter === "treatedWithoutLogisticianInspection";

  const onClick = useCallback(() => {
    clearAll();
    setQuickFilter("treatedWithoutLogisticianInspection");
  }, [clearAll, setQuickFilter]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "treatedWithoutLogisticianInspection",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  if (!results?.totalCount) return null;

  return (
    <QuickFilterItem
      count={results?.totalCount}
      active={active}
      title={t(
        "returnRequestsQuickFilters.treatedWithoutLogisticianInspection.title",
      )}
      description={t(
        "returnRequestsQuickFilters.treatedWithoutLogisticianInspection.description",
      )}
      icon={<ClipboardX className="size-3" color={orange} />}
      onClick={onClick}
    />
  );
}
